import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import LogoPng from '../../assets/images/Dur.png';
import DevolutionCover from '../../assets/images/DevolutionCover.jpg';
import AppleMusicIcon from '../../assets/images/appleMusicIcon.png';
import SpotifyIcon from '../../assets/images/spotifyIcon.png';
import YoutubeIcon from '../../assets/images/youtubeIcon.png';

const spotifyArtistUrl =
  'https://open.spotify.com/artist/3VkXDRgrwXM4HXaq9199PA?si=GHf7aq5ZRBGuSs6ToE7mFA';

const appleMusicArtistUrl =
  'https://music.apple.com/us/artist/d%C3%BCr/1649459578';

const youtubeChannelUrl =
  'https://www.youtube.com/channel/UC4K2296xBvfV8l3gP7wrNjw';

const Background = styled.div`
  background-color: black;
  height: 100%;
  width: 100%;
`;

const HomeDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  color: white;
  font-family: 'GeminaLaser';

  transition: all 1s ease;
`;

const Logo = styled.img`
  width: 25em;
  margin: 3em;

  @media (max-width: 768px) {
    width: 80vw;
    margin: 1em 0 2em 0;
  }
`;

const AlbumCover = styled.img`
  width: 40em;
  padding: 2em;
  margin: 0 2em 2em 2em;
  border: 3px solid darkgray;
  border-radius: 16px;
  box-shadow: 0 4px 8px 0 rgba(300, 300, 300, 0.6),
    0 6px 20px 0 rgba(300, 300, 300, 0.6);

  @media (max-width: 1150px) {
    width: 70vw;
    margin: 1em 0 2em 0;
    padding: 10vw;
  }
`;

const StreamingIcon = styled.img`
  width: 4em;
  margin: 0 2em;
  filter: grayscale(60%);

  @media (max-width: 768px) {
    width: 3em;
  }

  @media (max-width: 350px) {
    margin: 0 0.5em;
  }
`;

const ContentRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: 0 2em;
  font-size: 1.5em;
`;

const StreamingRow = styled.div`
  margin-bottom: 3em;
`;

const Footer = styled.footer`
  display: flex;
  justify-content: center;
  color: white;
  padding-bottom: 1em;
`;

const Main = () => {
  const [loaded, setLoaded] = useState(false);
  const { state } = useLocation();
  const { initialLoad } = state || {};

  useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    <Background>
      <HomeDiv $loaded={loaded} $initialLoad={initialLoad}>
        <Logo
          src={LogoPng}
          alt="Kickass Dur Logo (seriously, it's cool)"
        ></Logo>
        <StreamingRow>
          <a href={spotifyArtistUrl} target="_blank" rel="noreferrer">
            <StreamingIcon src={SpotifyIcon} alt="Spotify Link" />
          </a>
          <a href={appleMusicArtistUrl} target="_blank" rel="noreferrer">
            <StreamingIcon src={AppleMusicIcon} alt="Apple Music Link" />
          </a>
          <a href={youtubeChannelUrl} target="_blank" rel="noreferrer">
            <StreamingIcon src={YoutubeIcon} alt="Youtube Channel Link" />
          </a>
        </StreamingRow>
        <ContentRow>
          <p>Devolution now streaming everywhere!</p>
          <AlbumCover
            src={DevolutionCover}
            alt="Devolution album cover"
          ></AlbumCover>
        </ContentRow>
      </HomeDiv>
      <Footer>
        <small>&copy; Copyright 2023, Dür Music. All rights reserved.</small>
      </Footer>
    </Background>
  );
};

export default Main;
